u.Tabs = class extends u.BaseElement {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();
        this._active = this.firstElementChild; // the default active tab is the first one
        this._tabs = this.children;
        this.$changeActive();
    }

    $moveTo(query) {
        /**
         *
         */

        this._active = this.querySelector('#' + query);
        this.$changeActive();
        this.$onChange();
    }

    $changeActive() {
        // hide everything
        for (var i = 0; i< this._tabs.length; i++) {
            this._tabs[i].classList.add('u.hide@*');
        }
        // make active tab visible
        this._active.classList.remove('u.hide@*');
    }

    $onChange() {
        /**
         * Extendable function
         */
    }
};

u.Tabs.register('u-tab');